import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

interface StyleProps {
  mobile: boolean;
}

const useStyles = makeStyles<Theme, StyleProps>((theme: Theme) =>
  createStyles({
    container: {
      height: '100%',
      background: '#FAFAFA',
      justifyContent: 'center',
      alignItems: 'center',
    },
    itemContainer: {
      width: ({ mobile }: StyleProps) => (mobile ? '100%' : 700),
      height: ({ mobile }: StyleProps) => (mobile ? '100%' : 'fit-content'),
      borderRadius: 10,
      backgroundColor: theme.oysterTheme.cotton,
      textAlign: 'center',
    },
    logoContainer: { borderBottom: '2px solid #EEF0F2', padding: '36px 0 34px 0' },
    logo: { height: 50 },
    textContainer: { padding: '56px 16px 75px 16px' },
    title: { fontSize: '30px', fontWeight: 600, lineHeight: '42px' },
    message: {
      maxWidth: 512,
      fontSize: '16px',
      fontWeight: 500,
      lineHeight: '23px',
      margin: '40px auto 50px auto',
    },
    loader: { height: '50px !important', width: '50px !important' },
  }),
);

export default useStyles;
